<script lang="ts">
  /**
   * The legal footer: the Privacy / Terms links, small and left-justified,
   * below the bottom of the current content on every view state.
   *
   * Page chrome, like the stage: the container passes the same `inert`
   * expression the stage carries, so while a takeover or modal owns the
   * page, keyboard focus cannot reach the links from under it.
   */
  interface Props {
    inert?: boolean;
  }

  let { inert = false }: Props = $props();
</script>

<footer class="legal-footer" data-testid="legal-footer" {inert}>
  <a data-testid="legal-privacy" href="/about/privacy">Privacy</a>
  <span aria-hidden="true">·</span>
  <a data-testid="legal-terms" href="/about/terms">Terms</a>
</footer>

<style>
  .legal-footer {
    display: flex;
    gap: 0.75rem;
    justify-content: flex-start;
    padding: 0.75rem 1rem 1.5rem;
    font-size: 0.75rem;
  }

  .legal-footer a {
    color: var(--ink);
    opacity: 0.6;
  }

  .legal-footer a:hover,
  .legal-footer a:focus-visible {
    opacity: 1;
  }
</style>
